<template>
	<div id="Bigcoffeegathering" class="pub_pub">
		<div class="pub_title">
			<div class="img_logo">
				<img src="../imges/lebiao/dkyj.png" alt="">
			</div>
			<div class="title_t">
				<div class="imhg_ti">
					<img src="../imges/lebiao/dkyj_font.png" alt="">
				</div>
				<div class="sm_t">
					<div style="float:left"><span>交流</span><span style="color:#D7230C;">中心</span></div>
					<div class="sm_pub">分享|交流|推荐|评论</div>
				</div>
			</div>
			<router-link tag="div" class="ckgd" to="/Bigcoffeegatheringdetails">
				查看更多&nbsp;>
			</router-link>
		</div>
		<div class="Bigbig" style="box-shadow: 0 4px 24px rgba(0,0,0,.16);margin-top: 10px;">
			<router-link tag="div" :to="{path: '/dkyjdetail', query: {id:item.id,title:item.title}}" v-for="(item,index) in xptjlist" :key="index" class="Bigkk" style="border: 1px solid #ccc;box-sizing: border-box;box-shadow: rgb(0 0 0 / 16%) 0px 4px 24px;">
				<div class="Bigimg">
					<img v-lazy="item.picture" alt="">
				</div>
				<div class="Bigtitle" style="padding-left: 10px;color: #000;">
					{{item.title}}
				</div>
				<div class="Bigtitle red" style="text-align: left;padding-left: 10px;">
				  阅读 {{item.view}} &nbsp;&nbsp;&nbsp; 获赏￥{{item.money}} &nbsp;&nbsp;&nbsp;更多
				</div>
				<div class="1" style="width: 80%;height: 25px;background: rgb(247, 248, 250);margin-left: 10px;margin-top: 2.5px;color: darkgrey;line-height: 25px;font-size: 12px;padding-left: 10px;">
					评论:这船设计的真不错
				</div>
			</router-link>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				xptjlist: ''
			}
		},
		methods: {
			jumpTo() {
				//指定跳转的地址
				this.$router.replace('/Bigcoffeegatheringdetails')
			},
		},
		components:{
		},
		async mounted() {
			let res = await http.post('api/daka/index')
			this.xptjlist = res.data.data.splice(0,8)
		}
	}
</script>

<style>
	.Bigbig{
		width: 100%;
		height: 530px;
		margin-top: 20px;
		box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
	}
	
	.Bigkk{
		width: 24%;
		height: 240px;
		margin-left: 0.7%;
		float: left;
		margin-top: 20px;
	}
	
	.Bigimg{
		width: 100%;
		height: 170px;
	}
	
	.Bigimg>img{
		width: 100%;
		height: 100%;
	}
	
	.Bigtitle{
		font-size: 14px;
		color: darkgrey;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
	}
	.red{
		color: red;
		text-align: center;
	}
</style>